
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5SYww", function(module, exports) {
/* PagesItemActions.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $2SvFZ = parcelRequire("2SvFZ");


var $fFc6D = parcelRequire("fFc6D");


var $inPa6 = parcelRequire("inPa6");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $5pCWF = parcelRequire("5pCWF");


var $6MlZq = parcelRequire("6MlZq");


var $2vuKf = parcelRequire("2vuKf");


var $bwL2u = parcelRequire("bwL2u");

/* MultiSelectButton.tsx generated by @compiled/babel-plugin v2.0.0 */ /* This is an entrypoint for multi-select in the content tree. It opens the BulkActionsMenu, which can be found in @confluence/page-tree */ 



var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $4NZXC = parcelRequire("4NZXC");


var $fVUfS = parcelRequire("fVUfS");





var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $386eff14c577d57a$export$bf2468c1c6a5e659 = ({ onClick: onClick, isDisabled: isDisabled, spaceHasUserContent: spaceHasUserContent, isMultiSelectEnabled: isMultiSelectEnabled, isLoading: isLoading, isMobile: isMobile })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasFiredScreenEvent = (0, $42omo.useRef)(false); // only fire the screen event once when the sidebar is expanded
    (0, $42omo.useEffect)(()=>{
        const tryFireScreenEvent = ()=>{
            if ((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) === 'expanded' && !hasFiredScreenEvent.current) {
                hasFiredScreenEvent.current = true;
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'multiSelectButton'
                    }
                }).fire();
            }
        };
        tryFireScreenEvent();
        window.addEventListener('resize', tryFireScreenEvent);
        return ()=>{
            window.removeEventListener('resize', tryFireScreenEvent);
        };
    }, [
        createAnalyticsEvent
    ]);
    if (!spaceHasUserContent || isMobile || !isMultiSelectEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4NZXC))),
        label: intl.formatMessage($386eff14c577d57a$var$i18n.enableMultiSelect),
        appearance: "subtle",
        spacing: "compact",
        onClick: onClick,
        isTooltipDisabled: false,
        isDisabled: isLoading || isDisabled,
        tooltip: {
            content: isDisabled ? intl.formatMessage($386eff14c577d57a$var$i18n.disabledMultiSelectTooltipOnSearch) : undefined
        }
    });
};
const $386eff14c577d57a$export$46ea206025f7f52d = ({ onClick: onClick })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.Pressable), {
        "aria-label": intl.formatMessage($386eff14c577d57a$var$i18n.exitMultiSelectLabel),
        onClick: onClick,
        xcss: $386eff14c577d57a$var$styles.exit,
        analyticsContext: {
            source: 'contentTreeBulkActions',
            attributes: {
                name: 'exitMultiSelectButton'
            }
        }
    }, intl.formatMessage($386eff14c577d57a$var$i18n.exitMultiSelect));
};
const $386eff14c577d57a$var$i18n = (0, $aXWIB.defineMessages)({
    exitMultiSelect: {
        id: "space-views.exit-multi-select",
        defaultMessage: "Exit"
    },
    exitMultiSelectLabel: {
        id: "space-views.exit-multi-select-label",
        defaultMessage: "Exit multi-select mode"
    },
    enableMultiSelect: {
        id: "space-views.enable-multi-select",
        defaultMessage: "Select multiple items to edit. Only items you have permission to modify will be affected."
    },
    disabledMultiSelectTooltipOnSearch: {
        id: "space-views.disabled-multi-select-tooltip",
        defaultMessage: "Multi-select is disabled when searching"
    }
});
const $386eff14c577d57a$var$styles = {
    exit: "_11c8fhey _18zr1b66 _1pbykb7n _4t3igktf _bfhksm61 _syaz6x5g _9oik1r31 _1bnx8stv _jf4cnqa1"
};


const $313e848f91dccb56$var$ActionsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _ylrp1tcg _gfex1tcg _u4yw1tcg _fbwg1tcg _ixx21tcg _1djk1tcg _1l991tcg _1fqg1tcg",
            __cmplp.className
        ])
    });
});

const $313e848f91dccb56$var$SpaceViewsMenuLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rKir-",
    name: "SpaceViewsMenuLoader",
    loader: async ()=>(await (parcelRequire("aM6zw"))).SpaceViewsMenu
});
const $313e848f91dccb56$export$bbecd2ee2d957a01 = ({ isLicensed: isLicensed, edition: edition, selection: selection, setSelection: setSelection, spaceKey: spaceKey, expandContentSection: expandContentSection, onItemClick: onItemClick, spaceHasUserContent: spaceHasUserContent, pageTreeFinishedLoading: pageTreeFinishedLoading, canManageContentOrSuperAdmin: canManageContentOrSuperAdmin, spaceViewsMenuTriggerRef: spaceViewsMenuTriggerRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const canShowFolder = selection === 'TREE';
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const isCreationADropdown = (0, $6MlZq.useIsCreationDropdownEnabled)();
    const [isContextualCreateFocused, setIsContextualCreateFocused] = (0, $42omo.useState)(false);
    const [isContextualCreatePopupOpen, setIsContextualCreatePopupOpen] = (0, $42omo.useState)(false);
    const [{ multiSelectMode: multiSelectMode }, { enterMultiSelect: enterMultiSelect, exitMultiSelect: exitMultiSelect }] = (0, $bwL2u.useContentTreeSelection)();
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    const [isMobile, setIsMobile] = (0, $42omo.useState)(false);
    const mediaQuery = (0, $fFc6D.UNSAFE_useMediaQuery)('below.md', function onChange(event) {
        // shifting between mobile and desktop
        if (isMultiSelectActive) exitMultiSelect();
        setIsMobile(event.matches);
    });
    (0, $42omo.useLayoutEffect)(()=>{
        setIsMobile(mediaQuery?.matches ?? false);
    }, [
        mediaQuery
    ]);
    const isMultiSelectEnabled = canManageContentOrSuperAdmin && edition === 'PREMIUM';
    const expandSideNav = (0, $2SvFZ.useExpandSideNav)();
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'contentTreeBulkActions',
                    action: 'closed',
                    actionSubject: 'bulkActionsMenu',
                    attributes: {
                        method: 'unmount'
                    }
                }
            }).fire();
            exitMultiSelect();
        };
    }, [
        createAnalyticsEvent,
        exitMultiSelect
    ]);
    const spaceViewsMenu = isLicensed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($313e848f91dccb56$var$SpaceViewsMenuLoader, {
        selection: selection,
        setSelection: setSelection,
        isWhiteboardBetaEnabled: isCreationADropdown,
        edition: edition,
        canManageContentOrSuperAdmin: canManageContentOrSuperAdmin,
        triggerRef: spaceViewsMenuTriggerRef
    }) : null;
    const contextualCreate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pCWF.ContextualCreateContentPopoverLoader), {
        isContextualCreateFocused: isContextualCreateFocused,
        setIsContextualCreateFocused: setIsContextualCreateFocused,
        shouldShowPopup: isContextualCreatePopupOpen,
        setShouldShowPopup: setIsContextualCreatePopupOpen,
        spaceKey: spaceKey,
        source: "spaceLevelContextualCreate",
        rootCreateButtonStyling: true,
        onItemClick: onItemClick,
        shouldRenderToParent: true,
        hideFolder: !canShowFolder
    }));
    const onMultiSelectClick = ()=>{
        expandSideNav();
        expandContentSection?.();
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'contentTreeBulkActions',
                action: 'opened',
                actionSubject: 'bulkActionsMenu',
                actionSubjectId: 'multiSelectButton'
            }
        }).fire();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'contentTreeBulkActions',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'multiSelectButton',
                attributes: {
                    spaceKey: spaceKey
                }
            }
        }).fire();
        enterMultiSelect();
    };
    const onExitMultiSelectClick = ()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'contentTreeBulkActions',
                action: 'closed',
                actionSubject: 'bulkActionsMenu',
                attributes: {
                    method: 'multiSelectExitButton'
                }
            }
        }).fire();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'contentTreeBulkActions',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'multiSelectExitButton'
            }
        }).fire();
        exitMultiSelect();
    };
    const actions = isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $386eff14c577d57a$export$46ea206025f7f52d), {
        onClick: onExitMultiSelectClick
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isMultiSelectEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $386eff14c577d57a$export$bf2468c1c6a5e659), {
        onClick: onMultiSelectClick,
        isDisabled: multiSelectMode === (0, $bwL2u.MultiSelectMode).DISABLED,
        isLoading: !pageTreeFinishedLoading,
        spaceHasUserContent: spaceHasUserContent,
        isMultiSelectEnabled: isMultiSelectEnabled,
        isMobile: isMobile
    }), contextualCreate, !isMultiSelectEnabled && spaceViewsMenu);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($313e848f91dccb56$var$ActionsContainer, {
        "data-vc": "pages-item-actions",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, actions));
};
module.exports["PagesItemActions"] = $313e848f91dccb56$export$bbecd2ee2d957a01;

});

parcelRegister("fFc6D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $bNwbD = parcelRequire("bNwbD");


var $bWLcG = parcelRequire("bWLcG");

const $1487a997836a60f3$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $1487a997836a60f3$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $42omo.useRef)(listener);
    (0, $42omo.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $1487a997836a60f3$var$queries[queryString];
    (0, $bNwbD.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $fFa3V.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
module.exports["UNSAFE_useMediaQuery"] = $1487a997836a60f3$export$49e55ae2c03d6045;

});

parcelRegister("bNwbD", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $95c4b21f9fd4bea1$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
module.exports["useLayoutEffect"] = $95c4b21f9fd4bea1$export$e5c5a5f917a5871c;

});

parcelRegister("bWLcG", function(module, exports) {

var $dhECE = parcelRequire("dhECE");

const $3d6428cbc8265f6c$export$c881183ca713c214 = (0, $dhECE.media);
module.exports["UNSAFE_media"] = $3d6428cbc8265f6c$export$c881183ca713c214;

});

parcelRegister("dhECE", function(module, exports) {
const $0e2eee81ad70e35e$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
module.exports["media"] = $0e2eee81ad70e35e$export$987d49ffe1b0900f;

});

parcelRegister("5pCWF", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0d9898c9e847c9be$export$e1b8a1ae03e64401 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8AYRE",
    name: "ContextualCreateContentPopoverLoader",
    loader: async ()=>(await (parcelRequire("dpVNI"))).ContextualCreateContentPopover
});
module.exports["ContextualCreateContentPopoverLoader"] = $0d9898c9e847c9be$export$e1b8a1ae03e64401;

});

parcelRegister("dpVNI", function(module, exports) {

let $9c4a7239567b78f0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9c4a7239567b78f0$var$load("cm1TN"),
    $9c4a7239567b78f0$var$load("cbazH"),
    $9c4a7239567b78f0$var$load("4fYzp"),
    $9c4a7239567b78f0$var$load("36XFx"),
    $9c4a7239567b78f0$var$load("excC5"),
    $9c4a7239567b78f0$var$load("6wr18"),
    $9c4a7239567b78f0$var$load("ffEVr"),
    $9c4a7239567b78f0$var$load("7EorR"),
    $9c4a7239567b78f0$var$load("hhss7"),
    $9c4a7239567b78f0$var$load("9F7vX")
]).then(()=>parcelRequire('2to2n'));

});

parcelRegister("6MlZq", function(module, exports) {
const $2b534f0161088f49$export$f5501c77c624c70 = ()=>{
    /**
	 * DO NOT MODIFY THIS METHOD.
	 * This method has been refactored to return true as part of an effort to remove LaunchDarkly feature flags.
	 * Returning true avoids regressions.
	 * This method will be removed when ALL dependent feature flags have been removed.
	 * This work is being tracked in https://hello.jira.atlassian.cloud/browse/CTIA-2808
	 */ return true;
};
module.exports["useIsCreationDropdownEnabled"] = $2b534f0161088f49$export$f5501c77c624c70;

});

parcelRegister("aM6zw", function(module, exports) {

let $7d837c208e5753be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7d837c208e5753be$var$load("3Bbwl"),
    $7d837c208e5753be$var$load("fC3D2")
]).then(()=>parcelRequire('a0Cao'));

});

parcelRegister("5X6QO", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("eOL5r")).disableNativeDragPreview);

var $eOL5r = parcelRequire("eOL5r");


});

parcelRegister("eOL5r", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $20c6df176d77bef6$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $20c6df176d77bef6$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $20c6df176d77bef6$var$tinyTransparentImage) nativeSetDragImage($20c6df176d77bef6$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $20c6df176d77bef6$export$c588cb30ff3b876e;

});

parcelRegister("gZctg", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("ihBqS")).preventUnhandled);

var $ihBqS = parcelRequire("ihBqS");


});

parcelRegister("ihBqS", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $cmcCB = parcelRequire("cmcCB");

function $713d889559578e2f$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $713d889559578e2f$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $713d889559578e2f$var$start() {
    $713d889559578e2f$var$cleanup();
    $713d889559578e2f$var$unbindEvents = (0, $fFa3V.bindAll)(window, [
        {
            type: 'dragover',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $713d889559578e2f$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $713d889559578e2f$var$cleanup
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: $713d889559578e2f$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $713d889559578e2f$var$cleanup() {
    $713d889559578e2f$var$unbindEvents?.();
    $713d889559578e2f$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $713d889559578e2f$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $713d889559578e2f$var$cleanup();
}
const $713d889559578e2f$export$453c0582481cc59d = {
    start: $713d889559578e2f$var$start,
    stop: $713d889559578e2f$var$stop
};
module.exports["preventUnhandled"] = $713d889559578e2f$export$453c0582481cc59d;

});

parcelRegister("efXed", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $42omo = parcelRequire("42omo");

const $02aebea47caa4c41$export$d158fa15757a1890 = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $02aebea47caa4c41$export$abfcaeeca4ae7a55 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useHasCustomTheme() {
    return (0, $42omo.useContext)($02aebea47caa4c41$export$d158fa15757a1890);
} : function useHasCustomTheme() {
    return (0, $42omo.useContext)($02aebea47caa4c41$export$d158fa15757a1890);
};
module.exports["HasCustomThemeContext"] = $02aebea47caa4c41$export$d158fa15757a1890;
module.exports["useHasCustomTheme"] = $02aebea47caa4c41$export$abfcaeeca4ae7a55;

});

parcelRegister("lcVz9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $g9Jfe = parcelRequire("g9Jfe");

function $6b6d58426e4ff3f5$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $6b6d58426e4ff3f5$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $6b6d58426e4ff3f5$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $g9Jfe.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, iconProps));
};
var $6b6d58426e4ff3f5$export$2e2bcd8739ae039 = $6b6d58426e4ff3f5$var$IconRenderer;
module.exports["default"] = $6b6d58426e4ff3f5$export$2e2bcd8739ae039;

});

parcelRegister("i63G2", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $g9Jfe = parcelRequire("g9Jfe");


var $fVUfS = parcelRequire("fVUfS");


var $4jOXe = parcelRequire("4jOXe");

const $c0a568cbd64db8db$var$styles = {
    root: "_zulp12x7 _11c8fhey _2rkofajl _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    rootT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564choq _1ggl1kl7",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $c0a568cbd64db8db$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $c0a568cbd64db8db$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
}; /**
    * Props shared by `ThemedPressable` and `ThemedAnchor`
    */ 
const $c0a568cbd64db8db$export$66240319f1f78d74 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $4pOgL.isReactCompilerActivePlatform)() ? function ThemedPressable(t0, ref) {
    const $ = (0, $frIzR.c)(20);
    let T0;
    let appearance;
    let hasBorder;
    let isDisabled;
    let isSelected;
    let shape;
    let t1;
    if ($[0] !== t0) {
        const { appearance: t2, shape: t3, isSelected: t4, isDisabled: t5, ...props } = t0;
        isSelected = t4;
        isDisabled = t5;
        appearance = t2 === undefined ? "default" : t2;
        shape = t3 === undefined ? "default" : t3;
        hasBorder = appearance === "default" || isSelected;
        T0 = (0, $fVUfS.Pressable);
        t1 = (0, $4jOXe.getPrimitiveSpreadProps)(props);
        $[0] = t0;
        $[1] = T0;
        $[2] = appearance;
        $[3] = hasBorder;
        $[4] = isDisabled;
        $[5] = isSelected;
        $[6] = shape;
        $[7] = t1;
    } else {
        T0 = $[1];
        appearance = $[2];
        hasBorder = $[3];
        isDisabled = $[4];
        isSelected = $[5];
        shape = $[6];
        t1 = $[7];
    }
    let t2;
    if ($[8] !== appearance || $[9] !== hasBorder || $[10] !== isDisabled || $[11] !== isSelected || $[12] !== shape) {
        t2 = (0, $1bHXt.cx)($c0a568cbd64db8db$var$styles.root, (0, $g9Jfe.fg)("platform-dst-shape-theme-default") && $c0a568cbd64db8db$var$styles.rootT26Shape, $c0a568cbd64db8db$var$shapeStyles[shape], hasBorder && $c0a568cbd64db8db$var$styles.border, $c0a568cbd64db8db$var$appearanceStyles[appearance], isSelected && $c0a568cbd64db8db$var$styles.selected, isDisabled && $c0a568cbd64db8db$var$styles.disabled, (0, $g9Jfe.fg)("platform-dst-motion-uplift-button") && $c0a568cbd64db8db$var$styles.interactiveMotion);
        $[8] = appearance;
        $[9] = hasBorder;
        $[10] = isDisabled;
        $[11] = isSelected;
        $[12] = shape;
        $[13] = t2;
    } else t2 = $[13];
    let t3;
    if ($[14] !== T0 || $[15] !== isDisabled || $[16] !== ref || $[17] !== t1 || $[18] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            ref: ref,
            type: "button",
            xcss: t2,
            isDisabled: isDisabled
        });
        $[14] = T0;
        $[15] = isDisabled;
        $[16] = ref;
        $[17] = t1;
        $[18] = t2;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
} : function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.Pressable), {
        ...(0, $4jOXe.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
                                                                                * We are using some style values that are outside of the strict
                                                                                * `@atlaskit/css` types.
                                                                                */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $1bHXt.cx)($c0a568cbd64db8db$var$styles.root, (0, $g9Jfe.fg)('platform-dst-shape-theme-default') && $c0a568cbd64db8db$var$styles.rootT26Shape, $c0a568cbd64db8db$var$shapeStyles[shape], hasBorder && $c0a568cbd64db8db$var$styles.border, $c0a568cbd64db8db$var$appearanceStyles[appearance], isSelected && $c0a568cbd64db8db$var$styles.selected, isDisabled && $c0a568cbd64db8db$var$styles.disabled, (0, $g9Jfe.fg)('platform-dst-motion-uplift-button') && $c0a568cbd64db8db$var$styles.interactiveMotion),
        isDisabled: isDisabled
    });
});
module.exports["ThemedPressable"] = $c0a568cbd64db8db$export$66240319f1f78d74;

});

parcelRegister("4jOXe", function(module, exports) {
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $9048d266fac6ebf2$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}
module.exports["getPrimitiveSpreadProps"] = $9048d266fac6ebf2$export$e4c95325a21f9785;

});


//# sourceMappingURL=PagesItemActions.0bf7a340.js.map
